import PropTypes from "prop-types";
import React from "react";
import { Box, Typography, Hidden } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { NavLink } from "react-router-dom";
import { DropdownSelect } from "../../DropdownSelect";

const useStyles = makeStyles(theme => ({
  link: {
    marginRight: theme.spacing(6),
    color: theme.palette.text.secondary,
    textDecoration: "none",
    "&.active": {
      borderBottom: `solid 1px ${theme.palette.primary.main}`,
      color: theme.palette.primary.main,
      background: "none"
    },
    [theme.breakpoints.down("md")]: {
      marginRight: 0
    }
  }
}));

function SmallScreenLinkGroup(props) {
  const { links, history } = props;
  function handleRouteChange(newRoute) {
    history.push(newRoute.value);
  }
  const options = links.map(link => {
    return {
      value: link.path,
      label: link.title,
      active: link.active
    };
  });
  const activeLink = options.find(link => link.active === true);
  return (
    <DropdownSelect
      options={options}
      value={activeLink}
      onChange={handleRouteChange}
    />
  );
}

SmallScreenLinkGroup.propTypes = {
  history: PropTypes.any,
  links: PropTypes.any
};

function LargeScreenLinkGroup(props) {
  const classes = useStyles();
  const { links } = props;

  return links.map(link => (
    <NavLink className={classes.link} to={link.path} key={link.title}>
      <Typography variant="button" noWrap>
        {link.title}
      </Typography>
    </NavLink>
  ));
}

export default function LinkGroup(props) {
  const { links, history } = props;
  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="flex-end"
      mb={{ xs: 3, md: 5 }}
      mt={{ xs: 4, md: 5 }}
      justifyContent={{ xs: "flex-end", md: "flex-start" }}
    >
      <Hidden mdDown>
        <LargeScreenLinkGroup links={links} />
      </Hidden>
      <Hidden mdUp>
        <SmallScreenLinkGroup links={links} history={history} />
      </Hidden>
    </Box>
  );
}

LinkGroup.propTypes = {
  links: PropTypes.any,
  history: PropTypes.any
};
